export default __webpack_public_path__ + "static/client6-0f86f86c5d1698657bba6902dc1e398e.svg";